import { render, staticRenderFns } from "./PanelProvisionListAdmin.vue?vue&type=template&id=561346d4&scoped=true&"
import script from "./PanelProvisionListAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelProvisionListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PanelProvisionListAdmin.vue?vue&type=style&index=0&id=561346d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561346d4",
  null
  
)

export default component.exports